import * as moment from 'moment'
import * as React from 'react'
import CollapseIcon from '../../../icons/ui/CollapseIcon'
import ExpandIcon from '../../../icons/ui/ExpandIcon'
import { IServiceObject } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import { IMembershipSpecialObject } from './MembershipPane'
import { Datepicker } from '@mobiscroll/react'
import { Checkbox, Input, Radio, Stepper, Select } from '@mobiscroll/react-latest'
import FormLabel from 'src/components/ui/form/FormLabel'

interface IMembershipListItemProps {
  service: IServiceObject
  onUpdate: (membership: IMembershipSpecialObject) => any
}

interface IMembershipListItemState {
  expanded: boolean
  membership: any
  months: string[]
  numberTypes: IDropdownOption[]
}

interface IDropdownOption {
  text: string
  value: string
}

class MembershipListItem extends React.Component<IMembershipListItemProps, IMembershipListItemState> {
  constructor(props: any) {
    super(props)

    this.state = {
      expanded: false,
      membership: {},
      months: [
        UIMessages.common.months.januaryShortName,
        UIMessages.common.months.februaryShortName,
        UIMessages.common.months.marchShortName,
        UIMessages.common.months.aprilShortName,
        UIMessages.common.months.mayShortName,
        UIMessages.common.months.juneShortName,
        UIMessages.common.months.julyShortName,
        UIMessages.common.months.augustShortName,
        UIMessages.common.months.septemberShortName,
        UIMessages.common.months.octoberShortName,
        UIMessages.common.months.novemberShortName,
        UIMessages.common.months.decemberShortName
      ],
      numberTypes: [
        { value: 'Unlimited', text: UIMessages.common.unlimited },
        { value: 'Week', text: UIMessages.common.week },
        { value: 'Month', text: UIMessages.common.month },
        { value: 'Year', text: UIMessages.common.year }
      ]
    }
  }

  public componentDidMount() {
    const { service } = this.props
    const membership = {
      serviceId: service.id,
      eligibility: 'temporary',
      isLimitedByDate: true,
      beginsAt: moment(),
      expiresAt: moment().add(1, 'year'),
      isLimitedByRecurringMonths: false,
      recurringMonths: [],
      isLimitedByNumberOfRides: false,
      ridesRangeType: 'Week',
      ridesNum: 1,
      selected: false,
      isSuspended: false,
      suspensionUntil: new Date()
    }
    this.setState({ membership })
  }

  public render() {
    const { service } = this.props
    const innerContentStyle: any = {
      pointerEvents: this.state.membership.eligibility === 'permanent' ? 'none' : 'auto',
      opacity: this.state.membership.eligibility === 'permanent' ? 0.4 : 1.0,
      display: this.state.membership.eligibility === 'permanent' ? 'none' : 'block'
    }
    const contentStyle: any = {
      pointerEvents: !this.state.membership.selected ? 'none' : 'auto',
      opacity: !this.state.membership.selected ? 0.4 : 1.0
    }
    return (
      <div className='mt1 mb2'>
        {/* TOP */}
        <div className='rounded bg-light-grey3 p1'>
          <div className='flex'>
            {/* TODO: Add tooltip for description */}
            <div className='membership-title-header'>
              <Checkbox checked={this.state.membership.selected} onChange={this.onToggle} />
              <span className='MembershipTitle bold h5'>{service.name}</span>
            </div>
            <div style={{ flex: 1 }}>&nbsp;</div>
            <div>
              {!this.state.expanded && (
                <div style={{ cursor: 'pointer' }} onClick={this.onToggleExpand}>
                  <ExpandIcon className='icon--small svg-stroke-grey3 mr1' />
                </div>
              )}
              {this.state.expanded && (
                <div style={{ cursor: 'pointer' }} onClick={this.onToggleExpand}>
                  <CollapseIcon className='icon--small svg-stroke-grey3 mr1' />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* CONTENT */}
        {this.state.expanded && (
          <div style={contentStyle}>
            <div className='mt2'>
              <span>
                <FormLabel>{UIMessages.rider.externalMemberId}</FormLabel>
                <Input
                  onChange={this.onExternalId}
                  value={this.state.membership.externalRiderId}
                  className='mt02'
                  theme='ios'
                  themeVariant='light'
                />
              </span>
            </div>

            {/* Eligibility */}
            <div className='mt2'>
              <FormLabel>{UIMessages.common.eligibilityForService}</FormLabel>
              <span>
                <Radio
                  checked={this.state.membership.eligibility === 'permanent'}
                  onChange={this.onEligibilityPermanent}
                  label={UIMessages.common.permanent}
                />
                <Radio
                  checked={this.state.membership.eligibility === 'temporary'}
                  onChange={this.onEligibilityTemporary}
                  label={UIMessages.common.temporary}
                />
              </span>
            </div>
            {this.state.membership.eligibility !== 'permanent' && (
              <div>
                <div className='mb1 mr3 bb-shadow-grey'>&nbsp;</div>
                <FormLabel>Eligibility Limitation Type</FormLabel>
              </div>
            )}
            {/* Limited day/time */}
            <div style={innerContentStyle} className='mt1'>
              <div>
                <Radio
                  className='DayTimeCheckbox'
                  checked={this.state.membership.isLimitedByDate}
                  onChange={this.onLimitedDayTimeCheckbox}
                  label={UIMessages.common.limitedDayAndTime}
                />
              </div>
              {this.state.membership.isLimitedByDate && (
                <div className='flex mt1'>
                  <div className='mr1 flex-column ios-datepicker pb1 col-6'>
                    <div className='datepicker-label'>{UIMessages.common.startDayAndTime}</div>
                    <div>
                      <Datepicker
                        controls={['calendar', 'time']}
                        dateFormat='MM/DD/YYYY'
                        max={moment(new Date())}
                        min={moment().subtract(100, 'years')}
                        selected={this.state.membership.beginsAt}
                        onChange={this.onLimitedDateTimeStartChange}
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        labelStyle='floating'
                        touchUi={false}
                        display='anchored'
                        calendarScroll='horizontal'
                      />
                    </div>
                  </div>
                  <div className='ml1 flex-column ios-datepicker pb1 col-6'>
                    <div className='datepicker-label'>{UIMessages.common.endDayAndTime}</div>
                    <div>
                      <Datepicker
                        controls={['calendar', 'time']}
                        dateFormat='MM/DD/YYYY'
                        max={moment(new Date())}
                        min={moment().subtract(100, 'years')}
                        selected={this.state.membership.expiresAt}
                        onChange={this.onLimitedDateTimeEndChange}
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        labelStyle='floating'
                        touchUi={false}
                        display='anchored'
                        calendarScroll='horizontal'
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Number of rides */}
            <div style={innerContentStyle} className='mt1'>
              <div>
                <Radio
                  className='NumberOfRidesCheckbox'
                  checked={this.state.membership.isLimitedByNumberOfRides}
                  onChange={this.onNumberOfRidesCheckbox}
                  label={UIMessages.common.numberOfRides}
                />
              </div>
              {this.state.membership.isLimitedByNumberOfRides && (
                <div className='flex mt1 items-center'>
                  <Stepper
                    defaultValue={0}
                    value={this.state.membership.ridesNum}
                    onChange={this.onNumberOfRidesChange}
                    theme='material'
                    themeVariant='light'
                    inputStyle='box'
                  />
                  <label className='col-2 center h5 mr1'>{UIMessages.common.ridesPer}</label>
                  <span className='mt1'>
                    <Select
                      value={this.state.membership.ridesRangeType}
                      onChange={this.onridesRangeType}
                      data={this.state.numberTypes}
                      touchUi={false}
                      theme='ios'
                      themeVariant='light'
                      inputStyle='box'
                    />
                  </span>
                </div>
              )}
            </div>
            {/* Recurring */}
            <div style={innerContentStyle} className='mt1'>
              <div>
                <Radio
                  className='RecurringCheckbox'
                  checked={this.state.membership.isLimitedByRecurringMonths}
                  onChange={this.onRecurringCheckbox}
                  label={UIMessages.common.recurring}
                />
              </div>
              {this.state.membership.isLimitedByRecurringMonths && (
                <div className='flex flex-column mt1 ml1'>
                  <FormLabel>Choose Recurring Months:</FormLabel>
                  <div style={{ width: '30%' }} className='mt1 ml1 inline-block'>
                    {Object.keys(this.state.months).map((item, i) => (
                      <div style={{ width: '49%' }} className={'Month' + i + ' inline-block'} key={`tmli-${i}`}>
                        <Checkbox
                          checked={this.getRecurringMonthValue(this.state.months[item])}
                          onChange={this.onRecurringMonthChange(this.state.months[item])}
                          label={this.state.months[item]}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }

  private onLimitedDateTimeStartChange = (date: any) => {
    const membership = this.state.membership
    // membership.beginsAt = date.toDate()
    membership.beginsAt = date.value
    this.onUpdate(membership)
  }

  private onLimitedDateTimeEndChange = (date: any) => {
    const membership = this.state.membership
    // membership.expiresAt = date.toDate()
    membership.expiresAt = date.value
    this.onUpdate(membership)
  }

  private onNumberOfRidesChange = (event: any) => {
    const membership = this.state.membership
    membership.ridesNum = Number(event.target.value)
    this.onUpdate(membership)
  }

  private onridesRangeType = (event: any) => {
    const membership = this.state.membership
    membership.ridesRangeType = event.value
    this.onUpdate(membership)
  }

  private onRecurringMonthChange = (name: string) => () => {
    const membership = this.state.membership
    if (membership.recurringMonths.includes(name)) {
      delete membership.recurringMonths[membership.recurringMonths.indexOf(name)]
      this.onUpdate(membership)
      return
    }
    membership.recurringMonths.push(name)
    this.onUpdate(membership)
  }

  private getRecurringMonthValue = (name: string) => {
    for (const i in this.state.membership.recurringMonths) {
      if (this.state.membership.recurringMonths[i] === name) {
        return true
      }
    }
    return false
  }

  private onLimitedDayTimeCheckbox = () => {
    const membership = this.state.membership
    membership.isLimitedByDate = true
    membership.isLimitedByNumberOfRides = false
    membership.isLimitedByRecurringMonths = false
    this.onUpdate(membership)
  }

  private onNumberOfRidesCheckbox = () => {
    const membership = this.state.membership
    membership.isLimitedByNumberOfRides = true
    membership.isLimitedByDate = false
    membership.isLimitedByRecurringMonths = false
    this.onUpdate(membership)
  }

  private onRecurringCheckbox = () => {
    const membership = this.state.membership
    membership.isLimitedByRecurringMonths = true
    membership.isLimitedByDate = false
    membership.isLimitedByNumberOfRides = false
    this.onUpdate(membership)
  }

  private onEligibilityPermanent = () => {
    const membership = this.state.membership
    membership.eligibility = 'permanent'
    membership.isLimitedByNumberOfRides = false
    membership.isLimitedByDate = false
    membership.isLimitedByRecurringMonths = false
    this.onUpdate(membership)
  }

  private onEligibilityTemporary = () => {
    const membership = this.state.membership
    membership.eligibility = 'temporary'
    membership.isLimitedByDate = true
    this.onUpdate(membership)
  }

  private onExternalId = (e: any) => {
    const membership = this.state.membership
    membership.externalRiderId = e.target.value
    this.onUpdate(membership)
  }
  private onToggle = () => {
    const membership = this.state.membership
    membership.selected = !membership.selected
    this.onUpdate(membership)
  }

  private onUpdate = (membership: any) => {
    this.setState({ membership })
    this.props.onUpdate(membership)
  }

  private onToggleExpand = () => {
    this.setState({
      expanded: !this.state.expanded
    })
  }
}

export default MembershipListItem



// WEBPACK FOOTER //
// ./src/components/riders/createrider/membership/MembershipListItem.tsx